import Arrow from "../../../assets/Arrow";
import { Store, StoreDifferences } from "../../../types";
import { useNavigate } from "react-router-dom";

type Props =
    {
        store: Store,
        productDifferences: StoreDifferences | null,
        collectionDifferences: StoreDifferences | null,
        enabled: boolean
    }

export default function StoreCardDifferences({ store, productDifferences, collectionDifferences, enabled }: Props) {
    const navigate = useNavigate();
    const getReport = () => {
        navigate(`/management/${store.id}?tab=report`, { replace: true });
    }

    return (
        <button type="button" className="view-report-block" onClick={() => getReport()}>
            <div className="bottomArea compare">
                <div className="differences-info">
                    <div className="differences-div">
                        <div className={`sync-results ${!enabled ? 'sync-results--disabled' : ''}`}>
                            <div className="listed-differences">
                                <p className="progress-title blueTitle">PRODUCTS</p>
                                <div className="differences-container">
                                    <div className="column index">
                                        <p className="differences-column-title blackTitle">INDEX</p>
                                        <p className="differences-column-result">
                                            {productDifferences?.indexCount ?? 'na'}
                                        </p>
                                    </div>
                                    <div className="column shopify">
                                        <p className="differences-column-title blackTitle">SHOPIFY</p>
                                        <p className="differences-column-result">
                                            {productDifferences?.shopifyCount ?? 'na'}
                                        </p>
                                    </div>
                                    <div className="column system">
                                        <p className="differences-column-title blackTitle">RETAILSYS</p>
                                        <p className="differences-column-result">
                                            {productDifferences?.mirrorCount ?? 'na'}
                                        </p>
                                    </div>
                                </div>
                            </div>
                            <div className="listed-differences rightCol">
                                <p className="progress-title blueTitle">COLLECTIONS</p>
                                <div className="differences-container">
                                    <div className="column shopify">
                                        <p className="differences-column-title blackTitle">SHOPIFY</p>
                                        <p className="differences-column-result">
                                            {collectionDifferences?.shopifyCount ?? 'na'}
                                        </p>
                                    </div>
                                    <div className="column system">
                                        <p className="differences-column-title blackTitle">RETAILSYS </p>
                                        <p className="differences-column-result">
                                            {collectionDifferences?.mirrorCount ?? 'na'}
                                        </p>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <span className="view-report-bar">
                    <span className="view-report-bar__label">
                        <span className="view-report-bar__icon" aria-hidden="true" />
                        View report
                    </span>
                    <Arrow></Arrow>
                </span>
            </div>
        </button>
    )
}